import React from 'react';
import { FormattedNumber } from 'react-intl';

/**
 * Moved this to Launchpad from the component library because it was deprecated
 * and should not be a part of the ui-library.
 */

interface MoneyProps {
  value: number;
  currency?: string;
}

export const Money = ({
  value,
  currency = 'EUR',
  ...rest
}: MoneyProps) => (
  <FormattedNumber
    value={value / 100}
    currency={currency}
    style="currency"
    currencyDisplay="symbol"
    {...rest}
  />
);
